import { render, staticRenderFns } from "./NewmoonFooter.vue?vue&type=template&id=bea0adba&scoped=true"
import script from "./NewmoonFooter.vue?vue&type=script&lang=js"
export * from "./NewmoonFooter.vue?vue&type=script&lang=js"
import style0 from "./NewmoonFooter.vue?vue&type=style&index=0&id=bea0adba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea0adba",
  null
  
)

export default component.exports